import { render } from "./EcoefficiencyForm.vue?vue&type=template&id=549d8188&scoped=true"
import script from "./EcoefficiencyForm.vue?vue&type=script&lang=js"
export * from "./EcoefficiencyForm.vue?vue&type=script&lang=js"

import "./EcoefficiencyForm.vue?vue&type=style&index=0&id=549d8188&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549d8188"]])

export default __exports__